import { DateInput, Input, Label, Select } from "components";
import { useDepartement, useJobPosition, useMainLocation } from "pages/Card/Transaction/CreateNewEmployee/components/FormSection/utils";
import { useFilterStore } from "../../stores";
import moment from "moment";
import { useFormContext, useWatch } from "react-hook-form";
import { FormType } from "../../schemas";

export function FilterDetail(props: {
    start_date: string,
    end_date: string
}) {

    // hooks
    const { dataDepartement, isLoadingDepartement } = useDepartement()
    const { dataJobPosition, isLoadingJobPosition } = useJobPosition()
    const { dataMainLocation, isLoadingMainLocation } = useMainLocation()

    //  state
    const { filter, setFilter } = useFilterStore();

    // form
    const { control } = useFormContext<FormType>()

    const codeForm = useWatch({
        control,
        name: "code"
    })

    return (
        <>
            <div>
                <div className="flex lg:flex-row flex-col gap-2 lg:items-center">
                    <Label>ID SCHEDULE</Label>
                    <div>
                        <Input
                            placeholder="ID SCHEDULE"
                            value={codeForm}
                        />
                    </div>
                </div>
            </div>
            <div className="lg:flex lg:justify-between lg:items-end">
                <div className="flex gap-2 mb-3 items-center">
                    <div className="flex lg:flex-row flex-col gap-2 lg:items-center">
                        <Label>PERIODE</Label>
                        <div>
                            <DateInput
                                value={moment(props.start_date).format("DD/MM/YYYY")}
                                onChange={() => {}}
                                disabled
                            />

                        </div>
                        <div>
                            <DateInput
                                value={moment(props.end_date).format("DD/MM/YYYY")}
                                onChange={() => {}}
                                disabled
                            />

                        </div>
                    </div>
                </div>
                <div className="flex lg:items-end mb-4 lg:flex-row flex-col lg:justify-between gap-1">
                    <Select
                        label="DEPARTMENT"
                        placeholder="Select department"
                        className="lg:w-[200px] md:w-full me-2"
                        width={true}
                        isLoading={isLoadingDepartement}
                        options={[{ label: "ALL", value: "" }, ...dataDepartement]}
                        value={dataDepartement.find(
                            (item) => item.value === filter?.department) ??
                            { label: "ALL", value: "" }}
                        onChange={(e) =>
                            setFilter({ ...filter, department: e?.value ?? "" })
                        }
                    />
                    <Select
                        label="JOB POSITION"
                        placeholder="Select job position"
                        className="lg:w-[200px] md:w-full me-2"
                        width={true}
                        isLoading={isLoadingJobPosition}
                        options={[{ label: "ALL", value: "" }, ...dataJobPosition]}
                        value={
                            dataJobPosition.find((item) => item.value === filter?.jobpos) ??
                            { label: "ALL", value: "" }
                        }
                        onChange={(e) =>
                            setFilter({ ...filter, jobpos: e?.value ?? "" })
                        }
                    />
                    <Select
                        label="MAIN LOCATION"
                        placeholder="Select main location"
                        className="lg:w-[200px] md:w-full me-2"
                        width={true}
                        isLoading={isLoadingMainLocation}
                        options={[{ label: "ALL", value: "" }, ...dataMainLocation]}
                        value={dataMainLocation.find(
                            (item) => item.value === filter?.location) ??
                            { label: "ALL", value: "" }}
                        onChange={(e) =>
                            setFilter({ ...filter, location: e?.value ?? "" })
                        }
                    />
                </div>
            </div>
        </>
    )
}